const months = [
  {
    number: "01",
    name: "Jan",
  },
  {
    number: "02",
    name: "Feb",
  },
  {
    number: "03",
    name: "Mar",
  },
  {
    number: "04",
    name: "Apr",
  },
  {
    number: "05",
    name: "May",
  },
  {
    number: "06",
    name: "Jun",
  },
  {
    number: "07",
    name: "Jul",
  },
  {
    number: "08",
    name: "Aug",
  },
  {
    number: "09",
    name: "Sep",
  },
  {
    number: "10",
    name: "Oct",
  },
  {
    number: "11",
    name: "Nov",
  },
  {
    number: "12",
    name: "Dec",
  },
];

const stNumbers = ["1", "21", "31"];
const ndNumbers = ["2", "22"];
const rdNumbers = ["3", "23"];
const thNumbers = [
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
];

export const transformDate = (string) => {
  let date = string.split("-");

  let newDateObject = {
    day: "",
    month: "",
    year: "",
  };
  if (stNumbers.includes(date[2])) {
    newDateObject.day = `${date[2]}st`;
  } else if (ndNumbers.includes(date[2])) {
    newDateObject.day = `${date[2]}nd`;
  } else if (rdNumbers.includes(date[2])) {
    newDateObject.day = `${date[2]}rd`;
  } else if (thNumbers.includes(date[2])) {
    newDateObject.day = `${date[2]}th`;
  }
  newDateObject.month = months.filter((month) => month.number === date[1]).pop().name;

  newDateObject.year = date[0];
  let dateString = `${newDateObject.month} ${newDateObject.day}`;

  return dateString;
};

export default transformDate;
